import { useMutation, useQuery, useQueryClient, UseQueryResult } from 'react-query'
import { AxiosError } from 'axios'

import { useNotificationContext } from 'shared/context/Notifications'
import isAxiosError from 'shared/utils/helpers/isAxiosError'

import { fetchBlockDetails, fetchCompanyData, saveCompanyData } from './services'
import { BlockDetailsType, CompanySettingsType } from './types'

export function useCompanyQuery(): UseQueryResult<CompanySettingsType> {
   return useQuery('companyData', fetchCompanyData, { refetchOnWindowFocus: true, retry: false })
}

export function useBlockDetailsQuery(): UseQueryResult<BlockDetailsType> {
   return useQuery('companyBlockDetails', fetchBlockDetails, { refetchOnWindowFocus: true })
}

export function useCompanyMutation() {
   const queryClient = useQueryClient()
   const { addNotification } = useNotificationContext()

   return useMutation<Result, AxiosError<ErrorType> | Error, CompanySettingsType, unknown>(
      (payload) => {
         return saveCompanyData(payload)
      },
      {
         onSuccess: (data) => {
            if (data.status === 204) {
               queryClient.invalidateQueries('companyData')
               queryClient.invalidateQueries('locations')
               addNotification('successSave', 'success')
            }
         },
         onError: (error) => {
            if (error) {
               if (isAxiosError<ErrorType>(error)) {
                  addNotification(error.response?.data?.errors[0].code || 'failedSave', 'error')
               } else {
                  addNotification('failedSave', 'error')
               }
            }
         },
      }
   )
}
